<script>
    import {
      ArrowUpIcon,
      CheckIcon,
      MapPinIcon,
      FacebookIcon,
      TwitterIcon,
      LinkedinIcon,
    } from "vue-feather-icons";
    
    import Navbar from "@/view/front/components/navbar";
    import Switcher from "@/view/front/components/switcher";
    import Footer from "@/view/front/components/footer";
    import axios from "axios";
    import Swal from "sweetalert2";
    import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
    import { API_URL, MEDIA_URL } from "@/core/api";
    import Skeleton from "@/view/front/components/skeleton";
    import IndexService from "@/MainServices/IndexService.js";
    import Multiselect from "vue-multiselect";
    import moment from "moment";
    // import Slider from '@vueform/slider/dist/slider.vue2.js'
    // import Slider from '@vueform/slider/dist/slider.vue2'
    // import VueSkeletonLoader from "skeleton-loader-vue";
    /**
     * page-jobs-new component
     */
    
    export default {
      metaInfo: function() {
        return {
          title: "Jobs in Pakistan - Find your dream job - job4u.pk",
          meta: [
            {
              name: "description",
              content:
                "Find your dream and latest Jobs in Pakistan from top recruiters, employers and companies in all over the Pakistan. Search and apply online now",
            },
          ],
        };
      },
      data() {
        return {
          myCitiesArray: [],
          minSalaryValue: 0,
          min_min: null,
          min_max: null,
          max_min: null,
          max_max: null,
          maxSalaryValue: 0,
          unspecified_salary: 0,
          auth: localStorage.getItem("id_token") !== null ? true : false,
          token: `Bearer ${localStorage.getItem("token")}`,
          loading: true,
          mediaUrl: MEDIA_URL,
          apiUrl: API_URL,
          data: [],
          cities: [],
          originalData: [],
          page_num: 1,
          show_load_more: true,
          search_text: "",
          jobFunctions: [],
          jobTypes: [],
          jobShifts: [],
          experiences: [],
          jobIndustries: [],
          viewsData: null,
          selected_job_functions: [],
          selected_job_type: [],
          selected_job_shift: [],
          selected_job_experience: [],
          selected_job_industry: [],
          salary_range: [],
          city: [],
          desiredSalaryOptions: [],
          detail: null,
          date_posted: "Anytime",
          datePostedItems: [],
          posted_by: "Anyone",
          postedByItems: [],
          applied: [],
          saveJobSuccess: {},
          savejobbtnclicked: [],
          classToggle: false,
          spinner: false,
          base_url: window.location.origin,
        };
      },
      components: {
        Navbar,
        Switcher,
        Footer,
        ArrowUpIcon,
        CheckIcon,
        MapPinIcon,
        Skeleton,
        Multiselect,
        FacebookIcon,
        TwitterIcon,
        LinkedinIcon,
      },
      mounted() {
        var link = !!document.querySelector("link[rel='canonical']")
          ? document.querySelector("link[rel='canonical']")
          : document.createElement("link");
        link.setAttribute("rel", "canonical");
        link.setAttribute(
          "href",
          location.protocol + "//" + location.host + location.pathname
        );
        document.head.appendChild(link);
        this.getResults(this.token);
        this.getViewsData();
        this.getJobFunctions();
        this.getJobTypes();
        this.getJobShifts();
        this.getJobCareerLevel();
        this.getJobIndustries();
        this.getMinSalary();
      },
      methods: {
        moment: function(date) {
          return moment(date);
        },
    
       async getMinSalary() {
         await axios
            .get(`${API_URL}/job_Application`)
            .then((res) => {
              this.min_min = res.data["min_min"];
              this.min_max = res.data["min_max"];
              this.max_min = res.data["max_min"];
              this.max_max = res.data["max_max"];
            })
            .catch(() => {
              this.loading = false;
            });
        },
       async getResults(token) {
          this.loading = true;
         await axios
            .get(`${this.apiUrl}/get_uregnt?page=${this.page_num}`)
            .then((response) => {
                alert('working')
              this.data = [...this.data, ...response.data.data];
              this.originalData = [...this.originalData, ...response.data.data];
              this.loading = false;
              if (response.data.next_page_url == null) {
                this.show_load_more = false;
              }
    
              const saveJobSuccess = this.saveJobSuccess;
              $.each(this.data, function(index, item) {
                axios.defaults.headers.common["Authorization"] = token;
                axios
                  .post(`${API_URL}/already-save-job`, {
                    job_id: item.id,
                  })
                  .then((response) => {
                    // console.log(response);
                    saveJobSuccess[item.id] = response.data.msg;
                  });
              });
              const applied = this.applied;
              $.each(this.data, function(index, item) {
                axios.defaults.headers.common["Authorization"] = token;
                axios
                  .post(`${API_URL}/save-check-applied-job`, {
                    job_id: item.id,
                  })
                  .then((res) => {
                    // console.log("Umer applied", applied);
                    if (res.data == true) {
                      applied[item.id] = true;
                    } else {
                      applied[item.id] = false;
                    }
                  });
              });
              IndexService.getCities().then((res) => {
                res.data.map((el) => {
                  this.cities.push({
                    id: el.id,
                    value: el.city_name,
                  });
                });
                var s = [
                  "Upto 20,000",
                  "20,001 - 40,000",
                  "40,001 - 60,000",
                  "60,001 - 80,000",
                  "80,001 - 100,000",
                  "100,001 - 125,000",
                  "125,001 - 150,000",
                  "150,001 - 175,000",
                  "175,001 - 225,000",
                  "225,001 - 275,000",
                  "275,001 - 300,000",
                  "300,000 - 350,000",
                  "350,000 +",
                ];
                s.map((el, i) => {
                  this.desiredSalaryOptions.push({
                    id: i,
                    value: el,
                  });
                });
                this.desiredSalaryOptions.unshift(
                  ...[{ id: "null", value: "Any salary" }]
                );
              });
            });
        },
    
        goToCity(item) {
          this.$router.replace({
            path: "/jobs/Pakistan/" + item,
            params: {
              search_text: this.search_text,
              selected_cities: [{ id: 1, value: item }],
            },
          });
        },
    
        makeTitle(slug) {
          var words = slug.split("-");
          for (var i = 0; i < words.length; i++) {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          }
          return words.join(" ").replace("  ", " & ");
        },
    
        changeSelect(n) {
          this.data = this.originalData;
          if (n.target.value === "all") {
            this.originalData = this.data;
            return;
          }
          var temp = [];
          this.data.forEach((element) => {
            if (element.job_type.indexOf(n.target.value) !== -1) {
              temp.push(element);
            }
          });
          this.data = temp;
        },
        loadmore() {
          this.page_num = this.page_num + 1;
          this.getResults(this.token);
        },
    
       async getJobFunctions() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-job-sectors`).then((response) => {
            this.jobFunctions = response.data;
          });
        },
       async getJobTypes() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-job-types`).then((response) => {
            this.jobTypes = response.data;
          });
        },
       async getJobShifts() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-job-shifts`).then((response) => {
            this.jobShifts = response.data;
          });
        },
       async getJobCareerLevel() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-job-career-levels`).then((response) => {
            this.experiences = response.data;
          });
        },
       async getJobIndustries() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-job-industries`).then((response) => {
            this.jobIndustries = response.data;
          });
        },
       async getViewsData() {
          this.loading = true;
         await axios.get(`${this.apiUrl}/get-views-data`).then((response) => {
            this.datePostedItems = [
              { title: "Anytime", value: "Anytime", days: "Anytime" },
              { title: "Today", value: response.data.today_job_count, days: 1 },
              {
                title: "Last Three Days",
                value: response.data.last_three_days_job_count,
                days: 3,
              },
              {
                title: "Last Week",
                value: response.data.last_week_job_count,
                days: 7,
              },
              {
                title: "Last Two Weeks",
                value: response.data.last_two_weeks_job_count,
                days: 14,
              },
            ];
            this.postedByItems = [
              { title: "Anyone", value: "Anyone", postedBy: "Anyone" },
              {
                title: "Recruitment Agencies",
                value: response.data.posted_by_agency,
                postedBy: "Agency",
              },
              {
                title: "Direct Employers",
                value: response.data.posted_by_employer,
                postedBy: "Direct Employer",
              },
              {
                title: "job4u.pk Network",
                value: response.data.posted_by_job4u,
                postedBy: "Data admin",
              },
            ];
          });
        },
      async filterSearch() {
          var check = false;
          if (parseInt(this.salary_range)) {
            this.salary_range.map((element) => {
              if (element.value == "Any salary") {
                check = true;
              }
            });
          }
          await axios
            .post(`${this.apiUrl}/filter-search-jobs`, {
              job_functions: this.selected_job_functions,
              job_type: this.selected_job_type,
              job_shift: this.selected_job_shift,
              // salary_range: this.salary_range || null,
              min_salary: this.minSalaryValue || null,
              max_salary: this.maxSalaryValue || null,
              unspecified_salary: this.unspecified_salary,
              city: this.city,
              experience: this.selected_job_experience,
              // salary_range_any: check,
              date_posted: this.date_posted,
              posted_by: this.posted_by,
            })
            .then((response) => {
              this.data = response.data;
              this.loading = false;
              if (this.data.length < 12) {
                this.show_load_more = false;
              } else {
                this.show_load_more = true;
              }
            });
        },
        clearFilter() {
          // location.reload();
          location.replace(window.location);
          this.search();
        },
       async search() {
          this.spinner = !this.spinner;
         await axios
            .post(`${this.apiUrl}/search-jobs`, {
              search_text: this.search_text,
              selected_cities: this.selected_cities,
              description_search: this.description_search,
              page_num: this.page_num,
            })
            .then((response) => {
              this.spinner = !this.spinner;
              console.log("RES", response.data);
              // this.myCitiesArray = null
    
              console.log("myCitiesArray =>", this.myCitiesArray);
    
              if (this.city.length > 0) {
                this.myCitiesArray = [];
                this.city.map((c) => {
                  this.myCitiesArray.push(c.value);
                });
                // filter by cities
                this.data = response.data.filter((job) =>
                  job.location_city.some((r) => this.myCitiesArray.includes(r))
                );
              } else {
                this.data = response.data;
              }
    
              this.loading = false;
              if (this.data.length < 12) {
                this.show_load_more = false;
              } else {
                this.show_load_more = true;
              }
            });
        },
        _unspecified_salaryFunction(event) {
          if (event.target.checked) {
            this.unspecified_salary = 1;
          } else {
            this.unspecified_salary = 0;
          }
        },
        _jobFunctionSelection(event) {
          var temp = [];
          if (event.target.checked) {
            if (!this.selected_job_functions.includes(event.target.value)) {
              temp = this.selected_job_functions;
              temp.push(event.target.value);
              this.selected_job_functions = temp;
            }
          } else {
            if (this.selected_job_functions.includes(event.target.value)) {
              temp = this.selected_job_functions;
              const index = temp.indexOf(event.target.value);
              if (index > -1) {
                temp.splice(index, 1);
              }
    
              this.selected_job_functions = temp;
            }
          }
        },
        _jobTypeSelection(event) {
          var temp = [];
          if (event.target.checked) {
            if (!this.selected_job_type.includes(event.target.value)) {
              temp = this.selected_job_type;
              temp.push(event.target.value);
              this.selected_job_type = temp;
            }
          } else {
            if (this.selected_job_type.includes(event.target.value)) {
              temp = this.selected_job_type;
              const index = temp.indexOf(event.target.value);
              if (index > -1) {
                temp.splice(index, 1);
              }
    
              this.selected_job_type = temp;
            }
          }
        },
        _jobShiftSelection(event) {
          var temp = [];
          if (event.target.checked) {
            if (!this.selected_job_shift.includes(event.target.value)) {
              temp = this.selected_job_shift;
              temp.push(event.target.value);
              this.selected_job_shift = temp;
            }
          } else {
            if (this.selected_job_shift.includes(event.target.value)) {
              temp = this.selected_job_shift;
              const index = temp.indexOf(event.target.value);
              if (index > -1) {
                temp.splice(index, 1);
              }
    
              this.selected_job_shift = temp;
            }
          }
        },
        _jobIndustrySelection(event) {
          var temp = [];
          if (event.target.checked) {
            if (!this.selected_job_industry.includes(event.target.value)) {
              temp = this.selected_job_industry;
              temp.push(event.target.value);
              this.selected_job_industry = temp;
            }
          } else {
            if (this.selected_job_industry.includes(event.target.value)) {
              temp = this.selected_job_industry;
              const index = temp.indexOf(event.target.value);
              if (index > -1) {
                temp.splice(index, 1);
              }
    
              this.selected_job_industry = temp;
            }
          }
        },
        _jobCareerSelection(event) {
          var temp = [];
          if (event.target.checked) {
            if (!this.selected_job_experience.includes(event.target.value)) {
              temp = this.selected_job_experience;
              temp.push(event.target.value);
              this.selected_job_experience = temp;
            }
          } else {
            if (this.selected_job_experience.includes(event.target.value)) {
              temp = this.selected_job_experience;
              const index = temp.indexOf(event.target.value);
              if (index > -1) {
                temp.splice(index, 1);
              }
    
              this.selected_job_experience = temp;
            }
          }
        },
       async singleDetail(item) {
          this.detail = item;
    
          axios.defaults.headers.common["Authorization"] = this.token;
         await axios
            .post(`${API_URL}/save-job-alerts`, {
              job_title: item.job_title,
              location: item.location_city,
            })
            .then((response) => {});
        },
       async saveJob(item) {
          // this.savejobbtnclicked[item.id] = response.data.msg;
         axios.defaults.headers.common["Authorization"] = this.token;
         await axios
            .post(`${API_URL}/save-job`, {
              job_id: item.id,
            })
            .then((response) => {
              this.saveJobSuccess[item.id] = response.data.msg;
              this.savejobbtnclicked[item.id] = response.data.msg;
              setTimeout(() => {
                this.savejobbtnclicked[item.id] = "";
              }, 3000);
              if (response.data.msg === "Job has been saved") {
                Swal.fire({
                  title: "",
                  text: "Job has been saved.",
                  icon: "success",
                  confirmButtonClass: "btn btn-secondary",
                  heightAuto: false,
                });
              } else {
                if (response.data.msg === "Job already saved") {
                  Swal.fire({
                    title: "",
                    text: "Job already saved.",
                    icon: "success",
                    confirmButtonClass: "btn btn-secondary",
                    heightAuto: false,
                  });
                }
              }
            });
        },
        ToggleSearch() {
          this.classToggle = !this.classToggle;
        },
      },
    };
    </script>
    <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
    
    <template>
      <div>
        <Navbar />
    
        <!-- <button type="button" @click="loadmore" v-if="show_load_more"> </button> -->
        <!-- Shape Start -->
        <div class="position-relative">
          <div class="shape overflow-hidden text-white"></div>
        </div>
        <!--Shape End-->
    
        <!-- anees -->
        <!-- Job List Start -->
    
        <section class="section pt-18">
          <div class="m-2">
            <Skeleton v-if="loading" class="pt-20" />
    
            <!-- mobile Search -->
            <div class="row hide_by_ch">
              <!-- hide_by_ch -->
              <div class="col-lg-12 col-12">
                <h1 class="job_lit_heading">Jobs in Pakistan</h1>
              </div>
              <div class="col-lg-12">
                <div class="input-group stylish-input-group3_ch">
                  <input
                    type="text"
                    class="form-control serach_i_ch"
                    placeholder="Search"
                    v-model="search_text"
                    @keyup.enter="search()"
                    style="padding: 10px 10px 10px 31px !important"
                  />
                  <img
                    data-v-07e2cee6=""
                    src="/images/s_1.svg"
                    width="15"
                    height="15"
                    alt="..."
                    class="icon_search__"
                  />
                </div>
    
                <div class="card mt-3">
                  <div
                    class="card-body new_multislect"
                    style="padding: 1px 7px 0px 33px !important"
                  >
                    <img
                      data-v-07e2cee6=""
                      src="/images/s_2.svg"
                      width="15"
                      height="15"
                      alt="..."
                      class="icon_search__"
                    />
                    <multiselect
                      id="multiselectCities"
                      deselect-label=""
                      select-label=""
                      v-model="city"
                      :height="300"
                      track-by="value"
                      class="p-0 pr-4"
                      :options="cities"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="City"
                      label="value"
                      :preselect-first="false"
                    >
                    </multiselect>
                  </div>
                </div>
    
                <button
                  @click="search()"
                  :class="{ spinner: spinner === true }"
                  class="job_btn_serh_list"
                >
                  Search
                </button>
                <button
                  class="job_btn_serh_list clear_mobile_new"
                  @click="clearFilter()"
                >
                  Clear search
                </button>
              </div>
              <button @click="ToggleSearch()" class="search__ch_btn">
                Advanced search
              </button>
            </div>
            <div class="row" style="margin-right: -15.5px">
              <div class="col-12">
                <div class="border-bottom">
                  <div class="row">
                    <div
                      class="col-lg-2 col-md-3 left_side_filer left_side_mobile"
                      :class="{ ToggleClass_ch: classToggle === true }"
                    >
                      <div class="card">
                        <div>
                          <div class="card-headerch filter_headingch m_title">
                            SALARY RANGE
                          </div>
                          <div>
                            <div class="form-group px-4">
                              <label for="formControlRange"
                                >min salary {{ this.minSalaryValue }}
                              </label>
                              <input
                                type="range"
                                v-bind:min="min_min"
                                v-bind:max="min_max"
                                v-model="minSalaryValue"
                                class="form-control-range"
                                id="formControlRange"
                              />
                            </div>
                            <div class="form-group px-4">
                              <label for="formControlRange"
                                >max salary {{ this.maxSalaryValue }}
                              </label>
                              <input
                                type="range"
                                v-bind:min="max_min"
                                v-bind:max="max_max"
                                v-model="maxSalaryValue"
                                class="form-control-range"
                                id="formControlRange"
                              />
                            </div>
    
                            <div class="card-body new_multislect">
                              <ul class="ul_p_l display-in-grid-imb">
                                <li>
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="unspecified_salary"
                                    value="unspecified_salary"
                                    name="unspecified_salary"
                                    v-on:click="_unspecified_salaryFunction($event)"
                                  /><label
                                    class="custom-control-label"
                                    style="font-size: 13px; text-transform: initial"
                                    for="unspecified_salary"
                                    >Unspecified salary</label
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
    
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          Location
                        </div>
                        <div class="card-body new_multislect">
                          <multiselect
                            id="multiselectCities"
                            deselect-label=""
                            select-label=""
                            v-model="city"
                            :height="300"
                            track-by="value"
                            :options="cities"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="City"
                            label="value"
                            :preselect-first="false"
                          >
                          </multiselect>
                        </div>
                      </div>
    
                      <div class="display-flex-on-mbl dnone_filter">
                        <div class="card">
                          <div class="card-headerch filter_headingch m_title">
                            Date Posted
                          </div>
                          <div class="card-body new_multislect pb-3">
                            <select
                              v-model="date_posted"
                              class="selectch form-control input_ch_h input_ch_h_new"
                            >
                              <option
                                v-for="item in datePostedItems"
                                :key="item.title + 'a'"
                                :value="item.days"
                              >
                                {{
                                  item.value !== "Anytime"
                                    ? item.title + `(${item.value})`
                                    : item.title
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="card">
                          <div class="card-headerch filter_headingch m_title">
                            Posted By
                          </div>
                          <div class="card-body new_multislect pb-3">
                            <select
                              v-model="posted_by"
                              class="selectch form-control input_ch_h input_ch_h_new"
                            >
                              <option
                                v-for="item in postedByItems"
                                :key="item.title + 'b'"
                                :value="item.postedBy"
                              >
                                {{
                                  item.value !== "Anyone"
                                    ? item.title + `(${item.value})`
                                    : item.title
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
    
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          JOB FUNCTIONS
                        </div>
                        <div class="card-body new_multislect">
                          <ul class="ul_p_l display-in-grid-imb">
                            <li
                              v-for="(item, index) in jobFunctions"
                              :key="index + 'c'"
                            >
                              <input
                                type="checkbox"
                                :id="item.job_function_name"
                                :name="item.job_function_name"
                                class="custom-control-input"
                                :value="item.job_function_name"
                                v-on:click="_jobFunctionSelection($event)"
                              /><label
                                class="custom-control-label"
                                :for="item.job_function_name"
                                style="font-size: 13px; text-transform: initial"
                                >{{ item.job_function_name }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          JOB TYPES
                        </div>
                        <div class="card-body new_multislect">
                          <ul class="ul_p_l display-in-grid-imb">
                            <li
                              v-for="(item, index) in jobTypes"
                              :key="index + 'd'"
                            >
                              <input
                                type="checkbox"
                                :id="item.job_type"
                                :name="item.job_type"
                                class="custom-control-input"
                                :value="item.job_type"
                                v-on:click="_jobTypeSelection($event)"
                              /><label
                                class="custom-control-label"
                                :for="item.job_type"
                                style="font-size: 13px"
                                >{{ item.job_type }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          JOB SHIFTS
                        </div>
                        <div class="card-body new_multislect">
                          <ul class="ul_p_l display-in-grid-imb">
                            <li
                              v-for="(item, index) in jobShifts"
                              :key="index + 'e'"
                            >
                              <input
                                type="checkbox"
                                :id="item.job_shift"
                                :name="item.job_shift"
                                class="custom-control-input"
                                :value="item.job_shift"
                                v-on:click="_jobShiftSelection($event)"
                              /><label
                                class="custom-control-label"
                                :for="item.job_shift"
                                style="font-size: 13px"
                                >{{ item.job_shift }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          CAREER LEVELS
                        </div>
                        <div class="card-body new_multislect">
                          <ul class="ul_p_l display-in-grid-imb">
                            <li
                              v-for="(item, index) in experiences"
                              :key="index + 'f'"
                            >
                              <input
                                type="checkbox"
                                :id="item.career_level"
                                :name="item.career_level"
                                class="custom-control-input"
                                :value="item.career_level"
                                v-on:click="_jobCareerSelection($event)"
                              /><label
                                class="custom-control-label"
                                :for="item.career_level"
                                style="font-size: 13px"
                                >{{ item.career_level }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-headerch filter_headingch m_title">
                          JOB INDUSTRY
                        </div>
                        <div class="card-body new_multislect">
                          <ul class="ul_p_l display-in-grid-imb">
                            <li
                              v-for="(item, index) in jobIndustries"
                              :key="index + 'g'"
                            >
                              <input
                                type="checkbox"
                                :id="item.industry_name"
                                :name="item.industry_name"
                                class="custom-control-input"
                                :value="item.industry_name"
                                v-on:click="_jobIndustrySelection($event)"
                              /><label
                                class="custom-control-label"
                                :for="item.industry_name"
                                style="font-size: 13px"
                                >{{ item.industry_name }}</label
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
    
                      <div
                        class="card hide_by_ch"
                        id="floating_search"
                        style="position: fixed"
                      >
                        <div
                          class="card-body"
                          style="
                            display: flex;
                            justify-content: space-around;
                            padding: 1.2rem;
                            padding-left: 5% !important;
                            padding-right: 5% !important;
                          "
                        >
                          <a href="#" style="width: 43%;margin-top: 5%;">
                            <button
                              type="button"
                              @click="filterSearch"
                              class="btn btn-sm btn-primary"
                              style=" bottom: 40px; padding: 5px;width: 100%;"
                            >
                              Apply
                            </button>
                          </a>
                          <button
                            type="button"
                            @click="clearFilter"
                            class="btn btn-sm btn-light"
                            style="margin-top: 5%; padding: 5px"
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                      <!-- mobile serach btn -->
                      <div
                        class="card hide_on_dectop_ch__"
                        id="floating_search"
                        :class="{ ToggleClass_ch: classToggle === true }"
                      >
                        <div
                          class="card-body"
                          style="
                            display: flex;
                            justify-content: space-around;
                            padding: 1.2rem;
                            padding-left: 5% !important;
                            padding-right: 5% !important;
                          "
                        >
                          <button
                            type="button"
                            @click="filterSearch"
                            class="btn btn-sm btn-primary"
                            style="margin-top: 5%; bottom: 40px; padding: 5px"
                          >
                            Apply
                          </button>
    
                          <button
                            type="button"
                            @click="clearFilter"
                            class="btn btn-sm btn-light"
                            style="margin-top: 5%; padding: 5px"
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
    
                    <div class="col-lg-6 col-md-9 pagech1 mt-0">
                      <div class="row">
                        <div class="col-lg-12 job_listing_header hide_on_mobile_ch">
                          <div class="simple-heading">
                            Jobs in Pakistan
    
                            <span class="pull-right">
                              <div class="navbar-form" role="search">
                                <div class="input-group stylish-input-group">
                                  <input
                                    type="text"
                                    class="form-control serach_i_ch"
                                    placeholder="Search"
                                    v-model="search_text"
                                    @keyup.enter="search()"
                                  />
                                  <span class="input-group-addon">
                                    <button type="button" class="ch_btn_submit">
                                      <span class="fa fa-search"></span>
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-12 col-md-7 col-12">
                          <div
                            v-if="data.length == 0"
                            class="text-bold blue text-center"
                            style="font-size: 24px"
                          >
                            No data found
                          </div>
                          <div
                            class="col-lg-12 row mx-0 col-md-4 col-12 pl-0 pr-0 job_list_d"
                            v-for="(item, index) in data"
                            :key="index + 'h'"
                            :style="index > 0 ? 'margin-top: 2%' : 'margin-top: 0%'"
                          >
                            <!-- {{ item.id }} -->
                            <div
                              class="card overflow-hidden ch-box"
                              :style="
                                item.urgent == 1
                                  ? 'background: #ffc6c638 !important'
                                  : ''
                              "
                            >
                              <div class="position position_style_ch row">
                                <router-link
                                  :to="
                                    '/jobs-careers/pakistan/' +
                                      item.location_city
                                        .map((v) => v.toLowerCase())
                                        .join('-') +
                                      '/' +
                                      item.job_title
                                        .toLowerCase()
                                        .replace(/ /g, '-')
                                        .replace(/[^\w-]+/g, '') +
                                      '/' +
                                      item.id
                                  "
                                  class="text-dark col-lg-10 col-8 title_job_by_ch"
                                  >{{ item.job_title }}
                                  <span class="job_function"
                                    >({{ item.job_function }})</span
                                  >
                                </router-link>
                                <div
                                  class="col-lg-2 col-4 pr-0 Urgent_hiring"
                                  style="text-align: end"
                                >
                                  <img
                                    v-if="item.feature == 1"
                                    src="images/job_page/Featured_new.svg"
                                    alt="..."
                                  />
                                </div>
                                <div class="co_name col-lg-9 col-8">
                                  <router-link
                                    style="font-size: 15px !important"
                                    :to="
                                      '/employer/' +
                                        item.recruiter.company_name
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        item.recruiter.id
                                    "
                                    class="company-name"
                                  >
                                    {{ item.recruiter.company_name }} </router-link
                                  ><span>
                                    <img
                                      src="images/job_page/Verified.svg"
                                      alt="..."
                                    />
                                  </span>
                                </div>
                                <div
                                  class="col-lg-3 col-4 pr-0 pl-0 Urgent_hiring"
                                  style="text-align: end"
                                >
                                  <img
                                    v-if="item.urgent == 1"
                                    src="/images/job_page/Urgent_hiring.svg"
                                    alt="..."
                                  />
                                </div>
                                <div
                                  class="col-lg-12 col-8 salary_style pl-3 pt-1"
                                  v-if="item.salary_min && item.salary_max"
                                >
                                  <img
                                    class="pr-2"
                                    src="images/job_page/Money.svg"
                                    alt="..."
                                  />
                                  <span> </span>
                                  {{ item.salary_min }} -
                                  {{ item.salary_max }}/Month
                                </div>
                                <div
                                  class="col-lg-12 col-8 salary_style pl-3 pt-1"
                                  v-if="item.salary_market_competitive == 1"
                                >
                                  <img
                                    class="pr-2"
                                    src="images/job_page/Money.svg"
                                    alt="..."
                                  />Market competitive Salary
                                </div>
                                <div
                                  class="col-lg-12 col-8 salary_style pl-3 pt-1"
                                  v-if="item.salary_depends_on_exp == 1"
                                >
                                  <img
                                    class="pr-2"
                                    src="images/job_page/Money.svg"
                                    alt="..."
                                  />Salary depends on exp
                                </div>
                                <div
                                  class="vew_details_btn col-lg-3 col-4 pr-0 pl-0 pb-2 pt-2 hide_on_dectop_ch"
                                >
                                  <router-link
                                    :to="
                                      '/jobs-careers/pakistan/' +
                                        item.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        item.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-')
                                          .replace(/[^\w-]+/g, '') +
                                        '/' +
                                        item.id
                                    "
                                    ><button>
                                      <img
                                        class="pr-1"
                                        src="/images/job_page/View.png"
                                        alt="..."
                                      />
                                      View Details
                                    </button></router-link
                                  >
                                </div>
                                <div class="col-12 hide_on_dectop_ch pl-3">
                                  <div class="media-body d-flex">
                                    <h4
                                      class="widget-title tooltipch mb-0 bold detail_heading"
                                    >
                                      <img
                                        class="pr-2"
                                        src="images/job_page/Due_date.svg"
                                        alt="..."
                                      />
                                      <span class="tooltiptextch"
                                        >Application deadline</span
                                      >
                                    </h4>
                                    <p
                                      class="text-primary mb-0 mb-0 detail_body"
                                      style="color: #a82511 !important"
                                    >
                                      {{
                                        moment(item.apply_by).format("MMMM Do YYYY")
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row pb-2 mx-0 pr-0">
                                  <div class="location_perant_div col-lg-9">
                                    <span>
                                      <img
                                        class="pr-2 location_icon_ch"
                                        src="images/job_page/Location.svg"
                                        alt="..."
                                      />
                                    </span>
                                    <div
                                      @click="goToCity(_item)"
                                      class="lo_name locations_style pl-1 pr-0 pt-2 d-flex"
                                      v-for="(_item, _index) in item.location_city"
                                      :key="_index + 'i'"
                                      style="cursor: pointer"
                                    >
                                      <span class="p-0 d-flex" v-if="_index < 4">
                                        <span
                                          class="p-0"
                                          v-if="
                                            _index > 0 &&
                                              _index < item.location_city.length
                                          "
                                          style=""
                                          >&nbsp;,&nbsp;</span
                                        >
    
                                        {{ _item }}
                                      </span>
                                      <span v-if="_index === 3" class="pt-0">
                                        , more location</span
                                      >
                                      <!-- </div> -->
                                    </div>
                                  </div>
                                  <div
                                    class="vew_details_btn col-lg-3 pr-0 pb-2 hide_on_mobile_ch"
                                    v-on:click="singleDetail(item)"
                                  >
                                    <button>
                                      <img
                                        class="pr-1"
                                        src="images/job_page/View.png"
                                        alt="..."
                                      />
                                      View Details
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-lg-12 pl-0 pt-3 d-flex job_description_style"
                                style="max-height: 85px; overflow: hidden"
                              >
                                <p v-html="item.job_description"></p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-12 row mx-0 col-md-4 col-12 pl-0 pr-0 job_list_m"
                            v-for="(item, index) in data"
                            :key="index + 'j'"
                            :style="index > 0 ? 'margin-top: 2%' : 'margin-top: 0%'"
                          >
                            <div
                              class="card overflow-hidden ch-box"
                              :style="
                                item.urgent == 1
                                  ? 'background: #ffc6c638 !important'
                                  : ''
                              "
                            >
                              <div class="position position_style_ch row">
                                <router-link
                                  :to="
                                    '/jobs-careers/pakistan/' +
                                      item.location_city
                                        .map((v) => v.toLowerCase())
                                        .join('-') +
                                      '/' +
                                      item.job_title
                                        .toLowerCase()
                                        .replace(/ /g, '-')
                                        .replace(/[^\w-]+/g, '') +
                                      '/' +
                                      item.id
                                  "
                                  class="text-dark col-lg-10 col-8 title_job_by_ch"
                                  >{{ item.job_title }}
                                </router-link>
                                <div
                                  class="col-lg-2 col-4 pr-0 vew_details_btn m-0"
                                >
                                  <router-link
                                    :to="
                                      '/jobs-careers/pakistan/' +
                                        item.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        item.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-')
                                          .replace(/[^\w-]+/g, '') +
                                        '/' +
                                        item.id
                                    "
                                    ><button class="py-0" style="font-weight: 400">
                                      <!-- <img
                                        class="pr-1"
                                        src="/images/job_page/View.png"
                                        alt="..."
                                      /> -->
                                      Details >>
                                    </button></router-link
                                  >
                                  <!-- <img
                                    v-if="item.feature == 1"
                                    src="images/job_page/Featured_new.svg"
                                    alt="..."
                                  /> -->
                                </div>
                                <div class="col-8 m-0 py-0">
                                  <span class="job_function">{{
                                    item.job_function
                                  }}</span>
                                </div>
                                <div
                                  class="col-4 pr-0 m-0 Urgent_hiring vew_details_btn"
                                  style="text-align: end"
                                >
                                  <img
                                    v-if="item.feature == 1"
                                    src="images/job_page/Featured_new.svg"
                                    alt="..."
                                  />
                                </div>
                                <div class="co_name col-lg-9 col-8">
                                  <span>
                                    <img
                                      src="images/job_page/Verified_m.svg"
                                      alt="..."
                                    />
                                  </span>
                                  <router-link
                                    style="font-size: 15px !important"
                                    :to="
                                      '/employer/' +
                                        item.recruiter.company_name
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        item.recruiter.id
                                    "
                                    class="company-name"
                                  >
                                    {{ item.recruiter.company_name }}
                                  </router-link>
                                </div>
                                <div
                                  class="col-lg-3 col-4 pr-0 pl-0 Urgent_hiring"
                                  style="text-align: end"
                                >
                                  <img
                                    v-if="item.urgent == 1"
                                    src="/images/job_page/Urgent_hiring.svg"
                                    alt="..."
                                  />
                                </div>
                                <div
                                  class="col-lg-12 col-8 salary_style pl-3 pt-1"
                                  v-if="item.salary_min && item.salary_max"
                                >
                                  <img
                                    class="pr-2"
                                    src="images/job_page/Money.svg"
                                    alt="..."
                                  />{{ item.salary_min }} -
                                  {{ item.salary_max }}/Month
                                </div>
                                <div class="col-12 hide_on_dectop_ch pl-3">
                                  <div class="media-body d-flex pt-2">
                                    <h4
                                      class="widget-title tooltipch mb-0 bold detail_heading"
                                    >
                                      <img
                                        class="pr-2"
                                        src="images/job_page/Due_date.svg"
                                        alt="..."
                                      />
                                      <span class="tooltiptextch"
                                        >Application deadline</span
                                      >
                                    </h4>
                                    <p
                                      class="text-primary mb-0 mb-0 detail_body"
                                      style="color: #a82511 !important"
                                    >
                                      {{
                                        moment(item.apply_by).format("MMMM Do YYYY")
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row pb-2 mx-0 pr-0">
                                  <div class="location_perant_div col-lg-9">
                                    <span>
                                      <img
                                        class="pr-2 location_icon_ch"
                                        src="images/job_page/Location.svg"
                                        alt="..."
                                      />
                                    </span>
                                    <div
                                      @click="goToCity(_item)"
                                      class="lo_name locations_style pl-1 pr-0 pt-2 d-flex"
                                      v-for="(_item, _index) in item.location_city"
                                      :key="_index + 'q'"
                                      style="cursor: pointer"
                                    >
                                      <span class="p-0 d-flex" v-if="_index < 4">
                                        <span
                                          class="p-0"
                                          v-if="
                                            _index > 0 &&
                                              _index < item.location_city.length
                                          "
                                          style=""
                                          >&nbsp;,&nbsp;</span
                                        >
    
                                        {{ _item }}
                                      </span>
                                      <span v-if="_index === 3" class="pt-0">
                                        , more location</span
                                      >
                                      <!-- </div> -->
                                    </div>
                                  </div>
                                  <div
                                    class="vew_details_btn col-lg-3 pr-0 pb-2 hide_on_mobile_ch"
                                    v-on:click="singleDetail(item)"
                                  >
                                    <button>
                                      <img
                                        class="pr-1"
                                        src="images/job_page/View.png"
                                        alt="..."
                                      />
                                      View Details
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-lg-12 pl-0 pt-3 d-flex job_description_style"
                                style="max-height: 85px; overflow: hidden"
                              >
                                <p v-html="item.job_description"></p>
                              </div>
                            </div>
                          </div>
    
                          <div
                            class="col-lg-12 col-md-4 col-12 d-none"
                            v-for="(item, index) in data"
                            :key="index + 'r'"
                            :style="index > 0 ? 'margin-top: 2%' : 'margin-top: 0%'"
                          >
                            <div
                              class="card job-box rounded border-0 overflow-hidden"
                            >
                              <div class="border-bottom">
                                <div class="position-relative">
                                  <img
                                    :src="mediaUrl + item.recruiter.banner"
                                    class="img-fluid"
                                    alt=""
                                    style="height: 198px; width: 100%"
                                  />
                                  <div class="job-overlay bg-white"></div>
                                </div>
                                <h5 class="mb-0 position">
                                  <router-link
                                    :to="
                                      '/jobs-careers/pakistan/' +
                                        item.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        item.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-')
                                          .replace(/[^\w-]+/g, '') +
                                        '/' +
                                        item.id
                                    "
                                    class="text-dark"
                                    >{{ item.job_title }}</router-link
                                  >
                                  <ul class="list-unstyled h6 mb-0 text-warning">
                                    <li class="list-inline-item mb-0">
                                      <i class="mdi mdi-star"></i>
                                    </li>
                                    <li class="list-inline-item mb-0">
                                      <i class="mdi mdi-star"></i>
                                    </li>
                                    <li class="list-inline-item mb-0">
                                      <i class="mdi mdi-star"></i>
                                    </li>
                                    <li class="list-inline-item mb-0">
                                      <i class="mdi mdi-star"></i>
                                    </li>
                                    <li class="list-inline-item mb-0">
                                      <i class="mdi mdi-star"></i>
                                    </li>
                                  </ul>
                                </h5>
                                <ul class="list-unstyled head mb-0">
                                  <li
                                    v-for="(_item, _index) in item.job_type"
                                    :key="_index + 's'"
                                    class="badge badge-success badge-pill"
                                  >
                                    {{ _item }}
                                  </li>
                                </ul>
                              </div>
    
                              <div class="card-body content position-relative">
                                <div
                                  class="firm-logo rounded-circle bg-light text-center"
                                >
                                  <img
                                    :src="mediaUrl + item.recruiter.profile_pic"
                                    class="avatar avatar-md-sm"
                                    alt=""
                                  />
                                </div>
                                <div class="company-detail text-center mt-3">
                                  <h5 class="mb-0">
                                    <router-link
                                      :to="
                                        '/employer/' +
                                          item.recruiter.company_name
                                            .toLowerCase()
                                            .replace(/ /g, '-') +
                                          '/' +
                                          item.recruiter.id
                                      "
                                      class="text-dark company-name"
                                      >{{
                                        item.recruiter.company_name
                                      }}</router-link
                                    >
                                  </h5>
                                  <p class="text-muted">
                                    <a
                                      @click="goToCity(_item)"
                                      class="video-play-icon text-muted"
                                      v-for="(_item, _index) in item.location_city"
                                      :key="_index + 'v'"
                                      style="cursor: pointer"
                                    >
                                      <map-pin-icon
                                        class="fea icon-sm"
                                      ></map-pin-icon>
                                      {{ _item }}
                                    </a>
                                  </p>
                                </div>
    
                                <div style="display: flex">
                                  <ul
                                    class="job-facts list-unstyled"
                                    style="
                                      width: 65%;
                                      display: flex;
                                      flex-direction: column;
                                    "
                                  >
                                    <li class="list-inline-item text-muted">
                                      <check-icon
                                        class="fea icon-sm text-success mr-1"
                                      ></check-icon>
                                      {{ item.minimum_experience_years + " years" }}
                                    </li>
                                    <li class="list-inline-item text-muted">
                                      <check-icon
                                        class="fea icon-sm text-success mr-1"
                                      ></check-icon>
                                      {{ item.job_function }}
                                    </li>
                                  </ul>
                                  <ul
                                    class="list-unstyled social-icon mb-0 mt-4"
                                    style="width: 35%"
                                  >
                                    <ShareNetwork
                                      network="twitter"
                                      :url="
                                        base_url +
                                          '/jobs-careers/pakistan/' +
                                          item.location_city
                                            .map((v) => v.toLowerCase())
                                            .join('-') +
                                          '/' +
                                          item.job_title
                                            .toLowerCase()
                                            .replace(/ /g, '-') +
                                          '/' +
                                          item.id
                                      "
                                      title=""
                                      description=""
                                      :quote="item.job_title"
                                      hashtags="job4u_pk"
                                      twitterUser="youyuxi"
                                    >
                                      <li
                                        class="list-inline-item ml-1"
                                        style="margin-right: 4%"
                                      >
                                        <a
                                          href="javascript:void(0)"
                                          class="rounded"
                                        >
                                          <twitter-icon
                                            class="fea icon-xs fea-social"
                                          ></twitter-icon>
                                        </a>
                                      </li>
                                    </ShareNetwork>
    
                                    <ShareNetwork
                                      network="facebook"
                                      :url="
                                        base_url +
                                          '/jobs-careers/pakistan/' +
                                          item.location_city
                                            .map((v) => v.toLowerCase())
                                            .join('-') +
                                          '/' +
                                          item.job_title
                                            .toLowerCase()
                                            .replace(/ /g, '-') +
                                          '/' +
                                          item.id
                                      "
                                      title=""
                                      description=""
                                      :quote="item.job_title"
                                      hashtags="job4u_pk"
                                    >
                                      <li
                                        class="list-inline-item"
                                        style="margin-right: 4%"
                                      >
                                        <a
                                          href="javascript:void(0)"
                                          class="rounded"
                                        >
                                          <facebook-icon
                                            class="fea icon-sm fea-social"
                                          ></facebook-icon>
                                        </a>
                                      </li>
                                    </ShareNetwork>
                                    <ShareNetwork
                                      network="linkedin"
                                      :url="
                                        base_url +
                                          '/jobs-careers/pakistan/' +
                                          item.location_city
                                            .map((v) => v.toLowerCase())
                                            .join('-') +
                                          '/' +
                                          item.job_title
                                            .toLowerCase()
                                            .replace(/ /g, '-') +
                                          '/' +
                                          item.id
                                      "
                                      title=""
                                      description=""
                                      :quote="item.job_title"
                                      hashtags="job4u_pk"
                                    >
                                      <li
                                        class="list-inline-item ml-1"
                                        style="margin-right: 4%"
                                      >
                                        <a
                                          href="javascript:void(0)"
                                          class="rounded"
                                        >
                                          <linkedin-icon
                                            class="fea icon-sm fea-social"
                                          ></linkedin-icon>
                                        </a>
                                      </li>
                                    </ShareNetwork>
                                  </ul>
                                </div>
                                <button
                                  v-on:click="singleDetail(item)"
                                  class="btn btn-outline-primary btn-block"
                                >
                                  View Details
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="col-lg-12 pl-0 pr-0 sidbar_ch_new" v-if="detail">
                        <!-- {{detail}} -->
                        <div class="card sidebar rounded border-0 rounded-0">
                          <div
                            class="card-body widget border-bottom cardbodych"
                            style=""
                          >
                            <h5 class="mb-0 bold position_style_ch border-0">
                              {{ detail.job_title }}
                              <!-- <span class="application_count"
                                >(Applicants:
                                {{ detail.job_application_count }})</span
                              > -->
                              <p
                                class="company-name mb-0"
                                style="font-size: 15px !important"
                              >
                                {{ detail.recruiter.company_name }}
                                <span>
                                  <img
                                    src="/images/job_page/Verified.svg"
                                    alt="..."
                                  />
                                </span>
                              </p>
                            </h5>
                            <button
                              class="badge badge-danger badge-pill"
                              @click="detail = false"
                            >
                              X
                            </button>
                          </div>
    
                          <div
                            class="job_details_btn pl-2 pr-2 pt-2 pb-0 border-bottom"
                          >
                            <router-link
                              v-if="auth && !applied[detail.id]"
                              :to="
                                '/jobs-careers/apply/pakistan/' +
                                  detail.location_city
                                    .map((v) => v.toLowerCase())
                                    .join('-') +
                                  '/' +
                                  detail.job_title
                                    .toLowerCase()
                                    .replace(/ /g, '-')
                                    .replace(/[^\w-]+/g, '') +
                                  '/' +
                                  detail.id
                              "
                              class="m-1 mt-1"
                              ><img src="/images/job_page/Apply.svg" alt="..."
                            /></router-link>
                            <!-- <router-link
                              v-if="auth && applied[detail.id]"
                              :to="
                                '/jobs-careers/apply/pakistan/' +
                                detail.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                detail.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '')
                              "
                              class="m-1"
                              ><img src="/images/job_page/Applied.png" alt="..."
                            /></router-link> -->
                            <button
                              type="button"
                              v-if="auth && applied[detail.id]"
                              @click="saveJob(detail)"
                              class="m-1"
                            >
                              <img src="/images/job_page/Applied.png" alt="..." />
                            </button>
                            <!-- <router-link
                              :to="
                                '/jobs-careers/pakistan/' +
                                detail.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                detail.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '')
                              "
                              class="btn btn-sm sidebar_btns btn_deteil_tns m-1"
                              >View Details</router-link
                            > -->
    
                            <button
                              type="button"
                              v-if="auth && !saveJobSuccess[detail.id]"
                              @click="saveJob(detail)"
                              class="m-1"
                            >
                              <img src="/images/job_page/Save.png" alt="..." />
                            </button>
                            <button
                              type="button"
                              v-if="auth && saveJobSuccess[detail.id]"
                              class="m-1"
                            >
                              <img src="/images/job_page/Saved.svg" alt="..." />
                            </button>
    
                            <a v-if="!auth" class="m-1" href="/login">
                              <img src="/images/job_page/Apply.png" alt="..." />
                            </a>
                            <a v-if="!auth" class="m-1" href="/login">
                              <img src="/images/job_page/Save.png" alt="..." />
                            </a>
    
                            <button type="button" class="m-1">
                              <img
                                src="/images/job_page/Invite_Friends.svg"
                                alt="..."
                              />
                            </button>
    
                            <!-- <button
                              type="button"
                              @click="detail = false"
                              class="btn btn-sm sidebar_btns_cls btn_deteil_tns m-1"
                            >
                              Close
                            </button> -->
                            <div class="icons">
                              <ul class="list-unstyled head mb-0">
                                <ul class="list-unstyled social-icon">
                                  <!-- style="text-align: right !important" -->
                                  <ShareNetwork
                                    network="twitter"
                                    :url="
                                      base_url +
                                        '/jobs-careers/pakistan/' +
                                        detail.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        detail.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        detail.id
                                    "
                                    title=""
                                    description=""
                                    :quote="detail.job_title"
                                    hashtags="job4u_pk"
                                    twitterUser="youyuxi"
                                  >
                                    <li
                                      class="list-inline-item ml-1"
                                      style="margin-right: 0%"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        class="rounded"
                                        style="border: none"
                                        title="Share on Twitter"
                                      >
                                        <twitter-icon
                                          class="fea icon-xs fea-social"
                                        ></twitter-icon>
                                      </a>
                                    </li>
                                  </ShareNetwork>
    
                                  <ShareNetwork
                                    network="facebook"
                                    :url="
                                      base_url +
                                        '/jobs-careers/pakistan/' +
                                        detail.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        detail.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        detail.id
                                    "
                                    title=""
                                    description=""
                                    :quote="detail.job_title"
                                    hashtags="job4u_pk"
                                  >
                                    <li
                                      class="list-inline-item"
                                      style="margin-right: 0%"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        class="rounded"
                                        style="border: none"
                                        title="Share on Facebook"
                                      >
                                        <facebook-icon
                                          class="fea icon-sm fea-social"
                                        ></facebook-icon>
                                      </a>
                                    </li>
                                  </ShareNetwork>
                                  <ShareNetwork
                                    network="linkedin"
                                    :url="
                                      base_url +
                                        '/jobs-careers/pakistan/' +
                                        detail.location_city
                                          .map((v) => v.toLowerCase())
                                          .join('-') +
                                        '/' +
                                        detail.job_title
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        detail.id
                                    "
                                    title=""
                                    description=""
                                    :quote="detail.job_title"
                                    hashtags="job4u_pk"
                                  >
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript:void(0)"
                                        class="rounded"
                                        style="border: none"
                                        title="Share on LinkedIn"
                                      >
                                        <linkedin-icon
                                          class="fea icon-sm fea-social"
                                        ></linkedin-icon>
                                      </a>
                                    </li>
                                  </ShareNetwork>
                                </ul>
                              </ul>
                            </div>
                          </div>
                          <div
                            class="card-body cardbodych2 pt-0"
                            style="overflow: auto"
                          >
                            <div class="row" style="margin-top: 1%">
                              <div class="border-bottom pl-4 pr-4 pb-2">
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center"
                                      style="margin-top: 5%"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Time_shift.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Job shift</span
                                          >
                                        </h4>
                                        <p
                                          class="text-primary mb-0 detail_body"
                                          v-for="(_item, _index) in detail &&
                                            detail.job_shift"
                                          :key="_index + '17'"
                                        >
                                          <span
                                            v-if="
                                              _index > 0 &&
                                                _index < detail.job_shift.length
                                            "
                                            style=""
                                            >,</span
                                          >
                                          {{ _item }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center"
                                      style="margin-top: 5%"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title mb-0 tooltipch bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Time_shift.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Employment type</span
                                          >
                                        </h4>
                                        <span
                                          class="text-primary mb-0 detail_body"
                                          v-for="(_item, _index) in detail &&
                                            detail.job_type"
                                          :key="_index + '18'"
                                        >
                                          {{ _item }}
                                        </span>
                                      </div>
                                    </div>
                                    <!-- <div class="media widget align-items-center mt-3">
                                  <div class="media-body d-flex">
                                    <h4
                                      class="widget-title mb-0 bold detail_heading"
                                    >
                                      <img
                                        class="pr-2"
                                        src="/images/job_page/Experience.png"
                                        alt="..."
                                      />
                                    </h4>
                                    <p class="text-primary mb-0 detail_body">
                                      {{
                                        detail &&
                                        detail.minimum_experience_years + " years"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                                  </div>
                                </div>
    
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <!-- salary_market_competitive -->
                                      <!-- salary_depends_on_exp -->
                                      <div
                                        class="media-body d-flex"
                                        v-if="
                                          detail &&
                                            detail.salary_min &&
                                            detail.salary_max
                                        "
                                      >
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Money_left.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Per month salary</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          {{ detail && detail.salary_min }} to
                                          {{ detail && detail.salary_max }}
                                        </p>
                                      </div>
                                      <div
                                        class="media-body d-flex"
                                        v-if="
                                          detail &&
                                            detail.salary_market_competitive == 1
                                        "
                                      >
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Money_left.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Per month salary</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          Market competitive salary
                                        </p>
                                      </div>
                                      <div
                                        class="media-body d-flex"
                                        v-if="
                                          detail &&
                                            detail.salary_depends_on_exp == 1
                                        "
                                      >
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Money_left.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Per month salary</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          Salary depends on exp
                                        </p>
                                      </div>
                                    </div>
                                  </div>
    
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title mb-0 tooltipch bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Sector.svg"
                                            alt="..."
                                            width="25"
                                          />
                                          <span class="tooltiptextch"
                                            >Job function</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          {{ detail && detail.job_function }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
    
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center"
                                      style="margin-top: 5%"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Applicants.svg"
                                            alt="..."
                                            width="25"
                                          />
                                          <span class="tooltiptextch"
                                            >Total applicants to date</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          <span
                                            v-if="detail.job_application_count < 50"
                                          >
                                            Less than 50
                                          </span>
                                          <span
                                            v-if="detail.job_application_count > 50"
                                          >
                                            More than 50
                                          </span>
                                          <!-- {{ detail.job_application_count }} -->
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center"
                                      style="margin-top: 5%"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/No._of_vacancies.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Number of vacancies</span
                                          >
                                        </h4>
                                        <span class="text-primary mb-0 detail_body">
                                          {{ detail.no_of_vacancies }} Vacancies
                                        </span>
                                      </div>
                                    </div>
                                    <!-- <div class="media widget align-items-center mt-3">
                                  <div class="media-body d-flex">
                                    <h4
                                      class="widget-title mb-0 bold detail_heading"
                                    >
                                      <img
                                        class="pr-2"
                                        src="/images/job_page/Experience.png"
                                        alt="..."
                                      />
                                    </h4>
                                    <p class="text-primary mb-0 detail_body">
                                      {{
                                        detail &&
                                        detail.minimum_experience_years + " years"
                                      }}
                                    </p>
                                  </div>
                                </div> -->
                                  </div>
                                </div>
    
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Education_required.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Minimum qualification</span
                                          >
                                        </h4>
                                        <p class="text-primary mb-0 detail_body">
                                          {{ detail && detail.education }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
    
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Gender_preference.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Gender preference</span
                                          >
                                        </h4>
                                        <p
                                          class="text-primary mb-0 detail_body"
                                          v-for="(_item, _index) in detail &&
                                            detail.gender"
                                          :key="_index + '19'"
                                        >
                                          <span
                                            v-if="
                                              _index > 0 &&
                                                _index < detail.gender.length
                                            "
                                            style=""
                                            >/</span
                                          >{{ _item }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
    
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Date_posted.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Job post date</span
                                          >
                                        </h4>
                                        <p
                                          class="text-primary mb-0 mb-0 detail_body"
                                        >
                                          {{
                                            moment(detail.created_at).format(
                                              "MMMM Do YYYY"
                                            )
                                          }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
    
                                  <div class="col col-md-6">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div class="media-body d-flex">
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Due_date.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Application deadline</span
                                          >
                                        </h4>
                                        <p
                                          class="text-primary mb-0 mb-0 detail_body"
                                        >
                                          {{
                                            moment(detail.apply_by).format(
                                              "MMMM Do YYYY"
                                            )
                                          }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
    
                                <div class="row" style="margin-top: 1%">
                                  <div class="col col-md-12">
                                    <div
                                      class="media widget align-items-center mt-3"
                                    >
                                      <div
                                        class="media-body location_ch"
                                        style="display: -webkit-box"
                                      >
                                        <h4
                                          class="widget-title tooltipch mb-0 bold detail_heading"
                                        >
                                          <img
                                            class="pr-2"
                                            src="/images/job_page/Location_left.svg"
                                            alt="..."
                                          />
                                          <span class="tooltiptextch"
                                            >Job locations</span
                                          >
                                        </h4>
                                        <div class="row">
                                          <p
                                            class="col col-md-3 text-primary mb-0 detail_body"
                                            style="display: contents"
                                          >
                                            <span
                                              v-for="(_item, _index) in detail &&
                                                detail.location_city"
                                              :key="_index + '20'"
                                              style="display: inline-flex"
                                            >
                                              <span
                                                v-if="
                                                  _index > 0 &&
                                                    _index <
                                                      detail.location_city.length
                                                "
                                                style=""
                                                >&nbsp;,&nbsp;</span
                                              >
                                              {{ _item }}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col col-md-12">
                                <div class="media widget align-items-center mt-3">
                                  <div class="media-body">
                                    <h4
                                      class="widget-title mb-0 bold detail_heading"
                                    >
                                      Job Description
                                    </h4>
                                    <p
                                      id="temp"
                                      class="para-desc mx-auto text-muted detail_body"
                                      v-html="detail.job_description"
                                    ></p>
                                    <!-- <p id="temp1" class="text-primary mb-0 mb-0"></p> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <router-link
                              v-if="auth && !applied[detail.id]"
                              :to="
                                '/jobs-careers/apply/pakistan/' +
                                detail.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                detail.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '')
                              "
                              class="btn btn-sm sidebar_btns"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                              >Apply Now <i class="mdi mdi-send text-white"></i
                            ></router-link>
                            <router-link
                              v-if="auth && applied[detail.id]"
                              :to="
                                '/jobs-careers/apply/pakistan/' +
                                detail.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                detail.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '')
                              "
                              class="btn btn-sm sidebar_btns_ch"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                              >Applied<i class="mdi mdi-send text-white"></i
                            ></router-link>
    
                            <router-link
                              :to="
                                '/jobs-careers/pakistan/' +
                                detail.location_city
                                  .map((v) => v.toLowerCase())
                                  .join('-') +
                                '/' +
                                detail.job_title
                                  .toLowerCase()
                                  .replace(/ /g, '-')
                                  .replace(/[^\w-]+/g, '')
                              "
                              class="btn btn-sm sidebar_btns"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                              >View Details</router-link
                            >
    
                            <button
                              type="button"
                              v-if="auth && !saveJobSuccess[detail.id]"
                              @click="saveJob(detail)"
                              class="btn btn-sm sidebar_btns"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                            >
                              Save <i class="mdi mdi-save"></i>
                            </button>
                            <button
                              type="button"
                              v-if="auth && saveJobSuccess[detail.id]"
                              class="btn btn-sm sidebar_btns_ch"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                            >
                              Saved <i class="mdi mdi-save"></i>
                            </button>
    
                            <button
                              type="button"
                              @click="detail = false"
                              class="btn btn-sm sidebar_btns_cls"
                              style="margin-top: 5%; bottom: 40px; margin-left: 2%"
                            >
                              Close
                            </button> -->
    
                            <!-- <div
                              class="alert alert-success"
                              role="alert"
                              style="margin-top: 10%"
                              v-if="savejobbtnclicked.length > 0"
                            >
                              {{ savejobbtnclicked }}
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <!--end col-->
                    </div>
                    <!-- popup -->
    
                    <!--end col-->
                  </div>
                  <!--end row-->
                </div>
              </div>
              <!--end col-->
            </div>
            <!--end row-->
    
            <!--end row-->
            <!-- <Skeleton v-if="loading" /> -->
            <div class="col-md-12 mt-10" style="text-align: center">
              <button
                type="button"
                @click="loadmore"
                class="btn btn_lood_ch"
                v-if="show_load_more"
              >
                Load More Jobs
              </button>
            </div>
          </div>
          <!--end container-->
        </section>
        <!--end section-->
        <!-- Job List End -->
        <!--end section-->
        <Footer />
        <!-- Footer End -->
        <Switcher />
        <!-- Back to top -->
        <a
          href="javascript: void(0);"
          class="btn btn-icon btn-soft-primary back-to-top"
          id="back-to-top"
          v-scroll-to="'#topnav'"
        >
          <arrow-up-icon class="icons"></arrow-up-icon>
        </a>
        <!-- Back to top -->
      </div>
    </template>
    